import { RatchetScheduleViewStyles } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/Securities/SecurityDetails/SecurityFeatures/Ratcheting/RatchetScheduleView/RatchetScheduleView.styles.tsx';
import { formatRatchetTierThreshold } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/Securities/SecurityDetails/SecurityFeatures/Ratcheting/RatchetScheduleView/RatchetScheduleView.utils.ts';
import {
	RatchetMetricType,
	RatchetScheduleItem,
} from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/Securities/SecurityDetails/SecurityFeatures/Ratcheting/data.mock.ts';
import { SortTag } from '@dealstack/frontend/shared/components/SortTag/SortTag.tsx';
import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { Flex, Text } from '@mantine/core';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon';

export const RatchetScheduleView = ({
	schedule,
	metricType,
}: {
	schedule: RatchetScheduleItem[];
	metricType?: RatchetMetricType;
}) => {
	const tCapManage = useTranslationCapManage();

	return (
		<RatchetScheduleViewStyles>
			{schedule.map((item, index) => {
				const thresholdLabel =
					index === 0
						? tCapManage('securities.ratcheting.schedule.initial_placeholder')
						: formatRatchetTierThreshold(tCapManage, item, metricType);
				const entitlementLabel = `${item.entitlement}%`;

				return (
					<div
						key={`${item.threshold ?? 'initial'}-${item.entitlement}`}
						className="item"
					>
						<Flex justify="center" align="center" className="item-head">
							<SortTag label={index} />
						</Flex>

						<Flex justify="center" align="center" gap="0.25rem" className="item-body">
							<Text c="dark.0">{thresholdLabel}</Text>

							<Icon variant="equal" size="lg" color="dark.0" />

							<Text c="dark.8">{entitlementLabel}</Text>
						</Flex>
					</div>
				);
			})}
		</RatchetScheduleViewStyles>
	);
};
